import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { exceptStyledProps, getRem } from '../../utils';
import { Container as Button } from '../../common/Button/styles';
import { FieldContainer, FieldEmotion } from '../Input/styles';

export interface ItemProps {
  width?: number;
}

export const Item = styled('div', exceptStyledProps('width'))<ItemProps>`
  position: relative;
  display: inline-block;
  width: ${props => getRem(props.width)};
`;

export const notFirstChildButton = css`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

export const notLastChildButton = css`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

export const Container = styled('div')`
  display: inline-flex;
  max-width: 100%;

  & > * {
    min-width: 0;
  }

  & > * + * {
    margin-left: 1px;
  }

  ${Button} {
    background-clip: padding-box;
  }

  /* Button children styles */
  & > ${Button} {
    &:not(:first-of-type) {
      ${notFirstChildButton};
    }

    &:not(:last-of-type) {
      ${notLastChildButton};
    }
  }

  /* Select children styles */
  & > .react-select__container {
    &:not(:first-child) {
      .react-select__control {
        ${notFirstChildButton};
      }
    }

    &:not(:last-child) {
      .react-select__control {
        ${notLastChildButton};
      }
    }
  }

  /* Input children styles */
  & > ${FieldContainer} {
    &:not(:first-child) {
      ${FieldEmotion} {
        ${notFirstChildButton};
      }
    }

    &:not(:last-child) {
      ${FieldEmotion} {
        ${notLastChildButton};
      }
    }
  }

  ${Item} {
    &:not(:first-child) {
      ${`${Button}:not(.select-button-remove)`},
      ${FieldEmotion},
      .react-select__control {
        ${notFirstChildButton};
      }
    }

    &:not(:last-child) {
      ${`${Button}:not(.select-button-remove)`},
      ${FieldEmotion},
      .react-select__control {
        ${notLastChildButton};
      }
    }
  }
`;
